import type { ValueOf } from 'type-fest';

export const EditListingTourConfigSteps = {
  SET_BOOKING_METHOD: 'setBookingMethod',
  SET_TIME_ZONE: 'setTimeZone',
  SET_AVAILABILITY: 'setAvailability',
  SET_TOUR_DURATION: 'setTourDuration',
  EDIT_BOOKING_METHOD: 'editBookingMethod',
  EDIT_AVAILABILITY: 'editAvailability',
  EDIT_TOUR_DURATION: 'editTourDuration',
} as const;

export type EditListingTourConfigSteps = ValueOf<typeof EditListingTourConfigSteps>;
